import React, { useEffect } from 'react';
import { Modal } from '@perxis-auto/ui-kit/lib/components/Modal';

import { FiltersWrapperProps } from './FiltersWrapper.types';

function FiltersWrapper({
  toggle,
  title,
  type,
  visible,
  className,
  children,
}: FiltersWrapperProps) {
  useEffect(() => {
    if (type === 'mobile' && visible) {
      toggle();
    } else if (type === 'desktop' && !visible) {
      toggle();
    }
  }, [type]);

  if (!visible) {
    return null;
  }

  if (type === 'desktop') {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  return (
    <Modal open fullscreen title={title} onCancel={() => toggle()} className={className}>
      {children}
    </Modal>
  );
}

export default FiltersWrapper;
